import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers(['root', 'description', 'links']);

/**
 * @typedef {import('@chakra-ui/styled-system').PartsStyleInterpolation<{
 *  keys: ("root" | "description" | "links")[]
 * }>} ActionLinksStyles
 */

export const actionLinksStyles = helpers.defineMultiStyleConfig({
  /**
   * Base styles for ActionLinks component
   *
   * @param {Object} args - Component arguments
   * @param {Contentful.ActionLinks} args.component - ActionLinks component data
   * @param {string} [args.displayStyle] - Display style (horizontal/vertical)
   *
   * @returns {ActionLinksStyles} - Component styles
   */
  baseStyle({component, displayStyle}) {
    return {
      root: {
        width: '100%',
      },
      description: {
        mb: 4,
      },
      links: {
        spacing: 4,
        alignItems: displayStyle === 'horizontal' ? 'center' : 'flex-start',
        flexWrap: displayStyle === 'horizontal' ? 'wrap' : 'nowrap',
      },
    };
  },
});
